import './src/scss/index.scss';
import 'bootstrap/dist/css/bootstrap.min.css';

export const shouldUpdateScroll = ({ routerProps }) => {
  const state = routerProps?.location?.state;
  let disableScrollUpdate = false;
  if (state?.disableScrollUpdate) disableScrollUpdate = state.disableScrollUpdate;
  return !disableScrollUpdate;
};
